module.exports = __webpack_public_path__ + "media/images/sp/specials/common/store_shibuya-499e9ee89aafeeb63bd57b3b8e661c09.jpg";